import React from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";

function SideBarTitle({ posts, postImage }) {
  return (
    <div className="rc-post-list">
      <ul>
        {Array.isArray(posts) && posts.length > 0
          ? posts.map((post) => (
              <li key={post._id}>
                <div className="rc-post-thumb">
                  <Link to={`/blog/${post._id}`}>
                    <img
                      src={postImage(post.mainImage.asset._ref)}
                      alt={post.title}
                    />
                  </Link>
                </div>
                <div className="rc-post-content">
                  <h5 className="title">
                    <Link to={`/blog/${post._id}`}>{post.title}</Link>
                  </h5>
                  <div className="rc-post-meta">
                    <ul>
                      <li>
                        <i className="far fa-calendar-alt" />
                        {format(new Date(post.publishedAt), "MMMM dd, yyyy")}
                      </li>
                      <li>
                        By <a href="/#">{post.author || "Admin"}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            ))
          : null}
      </ul>
    </div>
  );
}

export default SideBarTitle;
